import { render, staticRenderFns } from "./FrontCartItems.vue?vue&type=template&id=44325978&"
import script from "./FrontCartItems.vue?vue&type=script&lang=js&"
export * from "./FrontCartItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports